<template>
    <div>
        <!-- 新增 or 编辑 or 查看详情 -->
        <el-button
            type="success"
            icon="iconfont icon-fitness-huifu1"
            circle
            @click="$emit('update:show', 'index')">
        </el-button>

        <div class="mb-10"></div>

        <!-- 详情 -->
        <div class="measure-show-show" v-if="showData.type === 'show'">
            <div class="measure-show-title">
                {{ $t('Measurement.MembershipInformation') }}
                <el-tooltip
                    style="float: right;"
                    class="item"
                    effect="dark"
                    :content="$t('tooltip.edit')"
                    placement="top">
                    <div
                        @click="showData.type = 'edit'"
                        class="inline-block iconfont icon-fitness-bianji1 ml-4 cursor-pointer">
                    </div>
                </el-tooltip>
            </div>
            <div class="measure-show-detail">
                <div class="mb-5"><i>{{ $t('Measurement.Bodymeasuretime') }}：</i>{{ form.date }}</div>
                <div class="flex items-center measure-double-item mb-5">
                    <div><i>{{ $t('Client.Measure.weight') }}：</i>{{ form.height }} cm</div>
                    <div><i>{{ $t('Client.Measure.weight') }}：</i>{{ form.weight }} kg</div>
                </div>
                <div class="flex items-center measure-double-item mb-5">
                    <div><i>{{ $t('Measurement.Basalmetabolism') }}：</i>{{ form.metabolize }}</div>
                    <div><i>{{ $t('Measurement.Body_fat_percentage') }}：</i>{{ form.fatPercent }} %</div>
                </div>
                <div class="flex items-center measure-double-item mb-5">
                    <div><i>{{ $t('Measurement.fatcontent') }}：</i>{{ form.fatContent }} kg</div>
                    <div><i>{{ $t('Measurement.Skeletal_muscle_content') }}：</i>{{ form.skeletal }} kg</div>
                </div>
                <div class="flex items-center measure-double-item mb-5">
                    <div><i>{{ $t('Measurement.Bust') }}：</i>{{ form.bust }} cm</div>
                    <div><i>{{ $t('Measurement.Thewaist') }}：</i>{{ form.waistLine }} cm</div>
                </div>
                <div class="flex items-center measure-double-item mb-5">
                    <div><i>{{ $t('Measurement.Hipline') }}：</i>{{ form.hipLine }} cm</div>
                    <div><i>{{ $t('Measurement.L_Hipline') }}：</i>{{ form.armCircumferenceL }} cm</div>
                </div>
                <div class="flex items-center measure-double-item mb-5">
                    <div><i>{{ $t('Measurement.R_Hipline') }}：</i>{{ form.armCircumferenceR }} cm</div>
                    <div><i>{{ $t('Measurement.L_Thighcircumference') }}：</i>{{ form.thighCircumferenceL }} cm</div>
                </div>
                <div class="mb-5"><i>{{ $t('Measurement.R_Thighcircumference') }}：</i>{{ form.thighCircumferenceR }} cm</div>
                <!-- photograph 数组 -->
                <div><i>{{ $t('Measurement.Phototaking') }}：</i></div>
            </div>
        </div>

        <!-- 新增/编辑 -->
        <div v-else class="measure-show-show">
            <div class="measure-show-title">{{ $t('Client.Measure.data') }}</div>
            <el-form
                class="measure-show-detail"
                ref="form"
                :model="form"
                label-width="180px"
                label-suffix=":"
                label-position="right">
                <el-form-item :label="$t('Measurement.Bodymeasuretime')">
                    <el-date-picker
                        style="width: 60%;"
                        value-format="yyyy-MM-dd"
                        v-model="form.date"
                        type="date"
                        :placeholder="$t('Client.Measure.physicaltime')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('Measurement.height')">
                    <el-input type="number" style="width: 60%;" v-model="form.height"  />
                    <span class="ml-8">cm</span>
                </el-form-item>
                <el-form-item :label="$t('Client.Measure.weight')">
                    <el-input type="number" style="width: 60%;" v-model="form.weight"  />
                    <span class="ml-8">kg</span>
                </el-form-item>
                <el-form-item :label="$t('Measurement.Basalmetabolism')">
                    <el-input type="number" style="width: 60%;" v-model="form.metabolize"  />
                </el-form-item>
                <el-form-item :label="$t('Measurement.fatcontent')">
                    <el-input type="number" style="width: 60%;" v-model="form.fatContent"  />
                    <span class="ml-8">kg</span>
                </el-form-item>
            </el-form>
        </div>
        <div class="flex justify-center mt-10" v-if="showData.type !== 'show'">
            <el-button type="primary" @click="submit()">{{ $t('Common.save') }}</el-button>
        </div>
    </div>
</template>

<script>
import { Radio, RadioButton, RadioGroup, DatePicker } from 'element-ui';

export default {
    props: ['showData', 'clientId'],
    components: {
        ElRadio: Radio,
        ElRadioButton: RadioButton,
        ElRadioGroup: RadioGroup,
        ElDatePicker: DatePicker,
    },
    data() {
        return {
            form: {},
        };
    },
    created() {
        if (this.showData.type === 'add') this.crateData();
        else this.fetchData();
    },
    methods: {
        fetchData() {
            API.get(`client/body-test/${this.showData.row.id}`).then(res => {
                this.form = res;
            });
        },
        crateData() {
            this.form = {
                date: null,
                height: null,
                weight: null,
                metabolize: null,
                fatContent: null,
            };
        },
        submit() {
            let request;
            if (this.showData.type === 'add') request = API.post(`client/${this.clientId}/body-test`, this.form);
            else request = API.put(`client/body-test/${this.showData.row.id}`, this.form);
            request.then(res => {
                $ele.$message.success(this.$t('Message.save'));
                this.$emit('fetchData');
                this.$emit('update:show', 'index');
                this.$emit('update:showData', null);
            });
        },
    },
};
</script>
<style lang="scss">
.measure-show-show {
    border: 1px solid #e3e8f0;
    padding: 5px 0 15px;

    i {
        font-style: normal;
        color: #999;
    }
}
.measure-show-title {
    font-size: 15px;
    color: #212121;
    padding: 15px;
    border-bottom: 1px solid #e3e8f0;
}
.measure-show-detail {
    padding: 15px;
    font-size: 14px;
}
.measure-double-item {
    div {
        width: 50%;
    }
}
</style>
